import React, { useState } from 'react';

import makeStyles from '@material-ui/core/styles/makeStyles';
import Drawer from '@material-ui/core/Drawer';
import Tabs from '@material-ui/core/Tabs';

import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import { Divider, Hidden, IconButton } from '@material-ui/core';

const smDrawerWidth = '45%';
const mdDrawerWidth = '30%';

const useStyles = makeStyles((theme) => ({

    tabDrawer: {
        width: smDrawerWidth,
        [theme.breakpoints.only('sm')]: {
            width: mdDrawerWidth,
        },
    },
    backdropRoot: {
        zIndex: 100
    },
    drawerPaper: {
        height: `calc(100% - ${theme.spacing(11)}px)`,
        top: theme.spacing(11),
        width: smDrawerWidth,
        [theme.breakpoints.only('sm')]: {
            width: mdDrawerWidth,
        },
    },
    drawerBack: {
        padding: theme.spacing(1),
        display: 'flex',
        justifyContent: 'end',
    },
    tabs: {
        borderRight: `1px solid ${theme.palette.divider}`,
        width: '10%',
        [theme.breakpoints.down('sm')]: {
            width: '100%'
        }
    },
    tabsScroll: {
        overflowY: 'auto !important',
    },
    mobileExpand: {
        zIndex: theme.zIndex.drawer - 1,
        backgroundColor: theme.palette.primary.main,
        color: '#FFF',
        position: 'absolute',
        display: 'flex',
        alignItems: 'center',
        top: theme.spacing(14) + theme.spacing(1) / 2,
        borderRadius: theme.spacing(1),
        left: '-8px',
    }

}));

const CustomTabs = ({ children, ...rest }) => {

    const classes = useStyles();

    return (
        <Tabs
            orientation="vertical"
            variant="fullWidth"
            textColor="primary"
            indicatorColor="primary"
            className={classes.tabs}
            classes={{ fixed: classes.tabsScroll }}
            {...rest}
        >
            {children}
        </Tabs>
    );
}

export const FingotiTabs = ({ children, DrawerProps, ...rest }) => {

    const classes = useStyles();
    const [open, setOpen] = useState(false);

    //Attaches onClick prop to child elements, used to hide menu on menu itme click on mobile
    const attachOnClickProp = React.Children.map(children, child => {
        if (React.isValidElement(child)) {
            return React.cloneElement(child, { onClick: () => setOpen(false) });
        }
        return child;
    });

    return (
        <React.Fragment>
            <Hidden mdUp>
                <div className={classes.mobileExpand}>
                    <IconButton style={{ color: '#FFF', paddingRight: 0 }} onClick={() => setOpen(true)}>
                        <ChevronRightIcon />
                    </IconButton>
                </div>
                <Drawer
                    anchor='left'
                    variant='permenant'
                    className={classes.tabDrawer}
                    classes={{ paper: classes.drawerPaper }}
                    ModalProps={{
                        BackdropProps: {
                            classes: {
                                root: classes.backdropRoot,
                            },
                            onClick: () => setOpen(false)
                        }
                    }}
                    open={open}
                    {...DrawerProps}
                >
                    <div className={classes.drawerBack}>
                        <IconButton onClick={() => setOpen(false)} style={{ padding: 4 }}>
                            <ChevronLeftIcon />
                        </IconButton>
                    </div>
                    <Divider />
                    <CustomTabs
                        {...rest}
                    >
                        {attachOnClickProp}
                    </CustomTabs>
                </Drawer>
            </Hidden>
            <Hidden smDown>
                <CustomTabs
                    {...rest}
                >
                    {children}
                </CustomTabs>
            </Hidden>
        </React.Fragment>
    );
}